<template>
    <v-content>
      <router-view/>
    </v-content>
 </template>

<script>

export default {
  name: "App",

  data: () => ({
    //
  })
};
</script>
<style>
div {
  font-family: "Baloo 2", cursive !important;
}
</style>
